import { Address } from '@front/common/src/types/commons';
import { OnInputPhoneChangeArgs } from '@front/common/src/types/components';

type Utils = {
  changeValue: (state: any, name: string, mutate: (value: any) => any) => void;
};

export const updateAddress = ([addressToSet]: [Address], state: any, utils: Utils) => {
  (Object.keys(addressToSet) as (keyof typeof addressToSet)[]).forEach((field) => {
    utils.changeValue(state, field, () => addressToSet[field]);
  });
};

export type UpdatePhoneMutateValues = {
  phoneFormatted: string;
  isPhoneValid: boolean;
};

export const updatePhone = (
  [{ isValid, value, formattedValue }]: [OnInputPhoneChangeArgs],
  state: any,
  utils: Utils,
) => {
  utils.changeValue(state, 'phone', () => value);
  utils.changeValue(state, 'phoneFormatted', () => formattedValue);
  utils.changeValue(state, 'isPhoneValid', () => isValid);
};
